import { format_error } from "@/resources/apis/utils"
const apis = require("@/resources/apis");

const user = {
    endpoint: '/user',

    login: function(item) {
        let url = this.endpoint + "/auth"
        return new Promise((resolve, reject) => {
            apis.http_auth.post(url, item)
                .then(
                    response => resolve(response.data),
                    error => reject(format_error(error))
                )
        })
    },

    create: function (item) {
        let url = this.endpoint + "/admin"
        return new Promise((resolve, reject) => {
            apis.http_jwt.post(url, item)
                .then(
                    response => resolve(response.data),
                    error => reject(format_error(error))
                )
        })
    },

    summaries() {
        let url = this.endpoint + "/admin"
        return new Promise((resolve, reject) => {
            apis.http_jwt.get(url)
                .then(
                    response => resolve(response.data),
                    error => reject(format_error(error))
                )
        })
    },

    admin_details(key) {
        let url = this.endpoint + "/admin/" + key
        return new Promise((resolve, reject) => {
            apis.http_jwt.get(url)
                .then(
                    response => resolve(response.data),
                    error => reject(format_error(error))
                )
        })
    },

    admin_update: function (key, item) {
        let url = this.endpoint + "/admin/" + key
        return new Promise((resolve, reject) => {
            apis.http_jwt.put(url, item)
                .then(
                    response => resolve(response.data),
                    error => reject(format_error(error))
                )
        })
    },

    signup: function (item) {
        let url = this.endpoint + "/info"
        return new Promise((resolve, reject) => {
            apis.http_jwt.post(url, item)
                .then(
                    response => resolve(response.data),
                    error => reject(format_error(error))
                )
        })
    },

    user_details(key) {
        let url = this.endpoint + "/info/" + key
        return new Promise((resolve, reject) => {
            apis.http_jwt.get(url)
                .then(
                    response => resolve(response.data),
                    error => reject(format_error(error))
                )
        })
    },

    user_update: function (key, item) {
        let url = this.endpoint + "/info/" + key
        return new Promise((resolve, reject) => {
            apis.http_jwt.put(url, item)
                .then(
                    response => resolve(response.data),
                    error => reject(format_error(error))
                )
        })
    },

    reset: function (key, item) {
        let url = this.endpoint + "/settings/" + key
        return new Promise((resolve, reject) => {
            apis.http_jwt.patch(url)
                .then(
                    response => resolve(response.data),
                    error => reject(format_error(error))
                )
        })
    },
}

apis.user = user
console.log(apis)

export default apis